import { Box, Button, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../reduxStore/hooks";
import dayjs from "dayjs";


export function AuditDrawerDetails() {
    const theme = useTheme();
    let navigate = useNavigate();
    const auditListValue = useAppSelector(
        (state) => state.getAuditListRes
    );
    const [selectedRow, setSelectedRow] = useState<any>(null);
    useEffect(() => {
        setSelectedRow(auditListValue?.selectedAuditDetails)
    }, [auditListValue?.selectedAuditDetails])
    const redirectTimeline = () => {
        console.log("selectedRow", selectedRow);
        navigate(`/timeline-view`, { state: { selectedRow } });
    };

    if (!selectedRow) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50%',
                    textAlign: 'center',
                    color: theme.palette.text.secondary
                }}
            >
                {/* <ChevronRightIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} /> */}
                <Typography variant="h6" sx={{ mb: 1 }}>
                    Select an audit record
                </Typography>
                <Typography variant="body2">
                    Click on any row to view detailed information
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            {/* Patient Information Section */}
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, color: theme.palette.primary.main, fontWeight: 'bold' }}>
                    Patient Information
                </Typography>
                <Box sx={{ display: 'grid', gap: 1.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Patient ID:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {selectedRow.patientId || 'N/A'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Name:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {selectedRow?.givenName || selectedRow?.familyName
                                ? `${selectedRow.givenName ?? ""} ${selectedRow.familyName ?? ""}`.trim()
                                : "N/A"}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            DOB:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {dayjs(selectedRow.dob).format("dddd, MMM DD, YYYY") || 'N/A'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Gender:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {selectedRow.gender || 'N/A'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Username:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {" "} {selectedRow.userName || 'N/A'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Phone:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                           {""} {selectedRow.phone || 'N/A'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Pincode:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                           {" "} {selectedRow.pincode || 'N/A'}
                        </Typography>
                    </Box>
                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Modified Date:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {dayjs(selectedRow.modifiedDate).format("dddd, MMM DD, YYYY") || 'N/A'}
                        </Typography>
                    </Box>
                </Box>
            </Box>            

            {/* Action Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button
                    variant="contained"
                    size="medium"
                    sx={{
                        textTransform: "none",
                        color: "#fff",
                        fontWeight: "bold",
                        minWidth: 150
                    }}
                    onClick={redirectTimeline}
                >
                    View Timeline
                </Button>
            </Box>
        </Box>
    );
};
